import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Type, Icon } from "discover.medical.react-component-library";
import { BetaText } from "./BetaRedirector.styled";

const BetaRedirector = () => {
  // START - Remove post cutover
  const { pathname, search, hash } = useLocation();
  const history = useHistory();
  const [isBeta, setIsBeta] = useState(false);
  // END

  useEffect(() => {
    // START - Remove post cutover
    if (
      pathname.startsWith("/beta") &&
      typeof window?._INITIAL_DATA_ !== "undefined"
    ) {
      const redirectFromBeta = `${pathname.replace(
        /^\/beta/,
        ""
      )}${search}${hash}`;
      setIsBeta(true);
      history.replace(redirectFromBeta);
    }
    // END
  }, []);

  return (
    <>
      {isBeta && (
        <BetaText>
          <Icon
            icon={{
              glyph: "bookmark",
              color: "accent",
              size: "xl"
            }}
          />
          <Type
            element="i"
            display="block"
            color="accent"
            fontWeight="semibold"
          >
            BETA
          </Type>
        </BetaText>
      )}
    </>
  );
};

BetaRedirector.displayName = "BetaRedirector";
export default BetaRedirector;
